(function () {
    'use strict';

    angular.module("imApp").factory("postCalcService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 840,
                    parameters: parms || {}
                });
            },
            listWorks: function (parms) {
                return $ihttp.post({
                    method: 1091,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
